"use strict";

export class ProjectInfo {
  constructor() {
    //
  }
}
